import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _804c65b6 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _7a6a67d2 = () => interopDefault(import('../pages/development/index.vue' /* webpackChunkName: "pages/development/index" */))
const _28ee8136 = () => interopDefault(import('../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _2ac579a8 = () => interopDefault(import('../pages/account/info.vue' /* webpackChunkName: "pages/account/info" */))
const _132a064c = () => interopDefault(import('../pages/account/mfa.vue' /* webpackChunkName: "pages/account/mfa" */))
const _b94f982c = () => interopDefault(import('../pages/account/preferences.vue' /* webpackChunkName: "pages/account/preferences" */))
const _05f827a1 = () => interopDefault(import('../pages/account/register.vue' /* webpackChunkName: "pages/account/register" */))
const _c7f89fea = () => interopDefault(import('../pages/account/self-exclusion.vue' /* webpackChunkName: "pages/account/self-exclusion" */))
const _259feb5b = () => interopDefault(import('../pages/development/refresh.vue' /* webpackChunkName: "pages/development/refresh" */))
const _514954bd = () => interopDefault(import('../pages/offers/stamp-cards.vue' /* webpackChunkName: "pages/offers/stamp-cards" */))
const _635a4f4b = () => interopDefault(import('../pages/takeawaypay/activate.vue' /* webpackChunkName: "pages/takeawaypay/activate" */))
const _59130da6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'is-link-active',
  linkExactActiveClass: 'is-link-exactActive',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _804c65b6,
    name: "checkout"
  }, {
    path: "/development",
    component: _7a6a67d2,
    name: "development"
  }, {
    path: "/offers",
    component: _28ee8136,
    name: "offers"
  }, {
    path: "/account/info",
    component: _2ac579a8,
    name: "account-info"
  }, {
    path: "/account/mfa",
    component: _132a064c,
    name: "account-mfa"
  }, {
    path: "/account/preferences",
    component: _b94f982c,
    name: "account-preferences"
  }, {
    path: "/account/register",
    component: _05f827a1,
    name: "account-register"
  }, {
    path: "/account/self-exclusion",
    component: _c7f89fea,
    name: "account-self-exclusion"
  }, {
    path: "/development/refresh",
    component: _259feb5b,
    name: "development-refresh"
  }, {
    path: "/offers/stamp-cards",
    component: _514954bd,
    name: "offers-stamp-cards"
  }, {
    path: "/takeawaypay/activate",
    component: _635a4f4b,
    name: "takeawaypay-activate"
  }, {
    path: "/",
    component: _59130da6,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
